import { INITIAL_STATE as OPTIONS_INITIAL_STATE } from './options/reducers'

const initialState = {
  options: OPTIONS_INITIAL_STATE,
}

export default initialState